import { GraduationCap, Briefcase, FileCheck, Plane, Hotel, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const services = [
    {
      icon: GraduationCap,
      title: 'مشاوره مهاجرت تحصیلی',
      description: 'راهنمایی کامل برای انتخاب کشور، دانشگاه و رشته تحصیلی مناسب',
      features: ['مشاوره اختصاصی', 'بررسی سوابق تحصیلی', 'انتخاب بهترین مسیر'],
      link: '/services/education-consulting'
    },
    {
      icon: Plane,
      title: 'اخذ ویزا',
      description: 'آماده‌سازی مدارک و اخذ ویزای تحصیلی، کاری و توریستی',
      features: ['بررسی مدارک', 'تکمیل فرم‌ها', 'آماده‌سازی مصاحبه'],
      link: '/services/visa'
    },
    {
      icon: Hotel,
      title: 'رزرو هتل',
      description: 'رزرو هتل با بهترین قیمت و کیفیت',
      features: ['مقایسه قیمت', 'رزرو آنلاین', 'پشتیبانی 24 ساعته'],
      link: '/services/hotel'
    },
    {
      icon: FileText,
      title: 'نگارش رزومه و انگیزه‌نامه',
      description: 'نگارش حرفه‌ای رزومه، انگیزه‌نامه و مدارک مربوط',
      features: ['نگارش حرفه‌ای', 'بررسی تخصصی', 'ویرایش نامحدود'],
      link: '/services/resume'
    },
    {
      icon: FileCheck,
      title: 'اخذ پذیرش دانشگاه',
      description: 'پیگیری و اخذ پذیرش از بهترین دانشگاه‌های جهان',
      features: ['آماده‌سازی مدارک', 'نگارش استیتمنت', 'پیگیری تا پذیرش'],
      link: '/contact'
    },
    {
      icon: Briefcase,
      title: 'مشاوره کاری',
      description: 'راهنمایی برای یافتن شغل مناسب در خارج از کشور',
      features: ['رزومه‌نویسی', 'جستجوی فرصت شغلی', 'آماده‌سازی مصاحبه'],
      link: '/contact'
    },
  ];

  return (
    <div className="min-h-screen py-12" data-testid="services-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-light text-white mb-4" data-testid="page-title">خدمات ما</h1>
          <p className="text-zinc-400">راهنمایی کامل در تمام مراحل مهاجرت و تحصیل</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <Link
                key={service.title}
                to={service.link}
                data-testid={`service-card-${service.title}`}
                className="glass-effect border border-white/10 rounded-2xl p-8 hover:border-[#D4AF37]/30 transition-all gold-glow-hover cursor-pointer block"
              >
                <div className="w-14 h-14 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center mb-6">
                  <Icon size={28} className="text-[#D4AF37]" />
                </div>
                <h3 className="text-xl font-medium text-white mb-3">{service.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed mb-4">{service.description}</p>
                <ul className="space-y-2 mb-4">
                  {service.features.map((feature) => (
                    <li key={feature} className="flex items-center gap-2 text-sm text-zinc-300">
                      <span className="text-[#D4AF37]">•</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <div className="text-[#D4AF37] text-sm font-medium flex items-center gap-1">
                  <span>درخواست خدمت</span>
                  <span>←</span>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="glass-effect border border-[#D4AF37]/20 rounded-3xl p-12 text-center">
          <h2 className="text-3xl font-light text-white mb-4">آماده برای شروع هستید؟</h2>
          <p className="text-zinc-400 mb-8 max-w-2xl mx-auto">
            مشاوران حرفه‌ای ما آماده راهنمایی شما در هر مرحله از مهاجرت هستند
          </p>
          <Link
            to="/contact"
            data-testid="contact-cta"
            className="inline-flex items-center gap-2 px-8 py-4 bg-[#D4AF37] text-black rounded-full font-medium hover:bg-[#F3E5AB] transition-colors"
          >
            دریافت مشاوره رایگان
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;